import { render, staticRenderFns } from "./userRoles.vue?vue&type=template&id=300f5924"
import script from "./userRoles.vue?vue&type=script&lang=js"
export * from "./userRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports